// Change active thumbnail on scroll
const thumbs = document.querySelectorAll('.product__media-thumbnail-item');

window.addEventListener('scroll', (event) => {
  const fromTop = window.scrollY;
  const navHeight = document.querySelector('.outer-header-wrapper').clientHeight;

  if(!thumbs) return
    thumbs.forEach(thumb => {
    const section = document.querySelector(`.product__media-item[data-media-id="${thumb.dataset.mediaId}"]`);

      if (section) {
        if (section.offsetTop <= fromTop && section.offsetTop + section.clientHeight > fromTop) {
          thumb.classList.add('active');
        } else {
          thumb.classList.remove('active');
        }
      }
    });
});

// Scroll to image on thumbnail click
if(thumbs) {
thumbs.forEach(thumb => {
  thumb.addEventListener('click', event => {
    event.preventDefault();
    const section = document.querySelector(`.product__media-item[data-media-id="${event.currentTarget.dataset.mediaId}"]`);

    window.scrollTo({
      top: section.offsetTop,
      behavior: "smooth"
    });
  });
});
}

// Product zoom slider
const productZoom = new Swiper(document.querySelector('.product__media-carousel'), {
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
})

// Product mobile slider
const productSlider = document.querySelector('.product__media-list');
let productSliderInstance = {};
const settingsSlider = {
  loop: true,
  pagination: {
    el: '.product__media-pagination',
    clickable: true
  }
}

const quickViewSettingsSlider = {
  loop: true,
  // pagination: {
  //   el: '.product__media-pagination',
  //   clickable: true
  // },
  // draggable: true,
  navigation: {
    prevEl: '.product__media-button-prev',
    nextEl: '.product__media-button-next'
  },
}

// Product mobile slider
const productUpsellSlider = document.querySelector('.product__upsells-swiper');
let productUpsellSliderInstance = {};
const productUpsellSettingsSlider = {
  loop: false,
  slidesPerView: 'auto',
  spaceBetween: 10,
  navigation: {
    prevEl: '.upsell-arrow-left',
    nextEl: '.upsell-arrow-right'
  },
  breakpoints: {
    501: {
      slidesPerView: 2,
    }
  }
}

window.addEventListener('load', pdpSwiperOnLoadOrResize);
window.addEventListener('resize', pdpSwiperOnLoadOrResize);

function pdpSwiperOnLoadOrResize() {

  if(productSlider) {
    if(productSlider.closest("quick-view")) {
      if (!productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance = new Swiper('.product__media-list', quickViewSettingsSlider);
      }
    } else if (window.innerWidth > 768) {
      if (productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!productSlider.classList.contains('swiper-initialized')) {
        productSliderInstance = new Swiper('.product__media-list', settingsSlider);
      }
    }
  }

  if(productUpsellSlider != undefined) {
    if(window.innerWidth > 500) {
      if (productUpsellSlider.classList.contains('swiper-initialized')) {
        productUpsellSliderInstance.destroy({
          deleteInstance: true,
          cleanStyles: true
        });
      }
    } else {
      if (!productUpsellSlider.classList.contains('swiper-initialized')) {
        productUpsellSliderInstance = new Swiper(productUpsellSlider, productUpsellSettingsSlider);
      }
    }
  }
}

// Assign sticky position to thumbnails based on header height
const thumbnails = document.querySelector('.product__media-thumbnails');
const fromTop = document.querySelector('.header').offsetHeight + document.querySelector('.header').getBoundingClientRect().top;
if(thumbnails) thumbnails.style.top = `${fromTop - 1}px`;

// Announcement bar close fixes
const headerWrapper = document.querySelector('.header');
const closeButton = document.querySelector('.announcement-bar__close');
const elementsToChange = document.querySelectorAll('.from-top-will-change')

closeButton.addEventListener('click', event => {
  // Change top positioned elements
  if (elementsToChange.length) {
    elementsToChange.forEach(element => {
      element.style.top = `${headerWrapper.offsetHeight}px`;
    });
  }
});

// Size Guide
const openSizeGuide = document.querySelector('.product__open-size-guide');

if (openSizeGuide) {
  openSizeGuide.addEventListener('click', event => {
    event.preventDefault();
  });
}

// Product Form
customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();

    const submitButton = this.querySelector('[type="submit"]');
    const recipientForm = this.querySelector('gift-card-recipient');

    this.handleErrorMessage();
    if (recipientForm && !recipientForm.validate()) return;

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...this.serializeWithProperties(this.form),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    let addFailed = false;

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.status) {
          addFailed = true;
          if (recipientForm && parsedState.errors && typeof parsedState.errors === 'object') {
            recipientForm.displayErrors(parsedState.errors);
          } else {
            this.handleErrorMessage(parsedState.description || parsedState.message);
          }
          return;
        }

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        if (this.dataset.cartLimit != null) {
          const limit = Number(this.dataset.cartLimit);

          if (limit == parsedState.quantity) {
            const atcButtons = document.querySelectorAll('.product-form__submit');
            atcButtons.forEach(button => {
              button.remove();
            });
          }
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        if (addFailed) return;
        if (recipientForm) recipientForm.reset();
        this.cartDrawer.rerender(true);
      });
  }

  // Builds the cart/add.js JSON body, turning `properties[Key]` inputs into a
  // nested `properties` object (JSON bodies don't expand bracket notation).
  serializeWithProperties(form) {
    const data = {};
    const formData = new FormData(form);

    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) {
        if (value === '') continue;
        data.properties = data.properties || {};
        data.properties[match[1]] = value;
      } else {
        data[key] = value;
      }
    }

    return data;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});

// Gift Card Recipient (Shopify native "send to recipient" line item properties)
if (!customElements.get('gift-card-recipient')) {
  customElements.define('gift-card-recipient', class GiftCardRecipient extends HTMLElement {
    static MAX_SEND_DAYS = 90;

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.checkbox = this.querySelector('.gift-card-recipient__checkbox');
      this.fieldsWrapper = this.querySelector('.gift-card-recipient__fields');
      this.fields = this.querySelectorAll('[data-recipient-field]');
      this.offsetInput = this.querySelector('[data-recipient-offset]');
      this.messageInput = this.querySelector('[data-recipient-field="message"]');
      this.dateInput = this.querySelector('[data-recipient-field="send_on"]');
      this.counter = this.querySelector('[data-count]');
      this.errorSummary = this.querySelector('.gift-card-recipient__error-summary');
      this.errorSummaryText = this.querySelector('.gift-card-recipient__error-summary-text');

      this.setDateLimits();
      this.toggle();

      // Open the native date picker when any part of the input is clicked.
      if (this.dateInput) {
        this.dateInput.addEventListener('click', () => {
          if (typeof this.dateInput.showPicker !== 'function') return;
          try { this.dateInput.showPicker(); } catch (e) { /* not allowed here; ignore */ }
        });
      }

      this.checkbox.addEventListener('change', () => this.toggle());
      if (this.messageInput) {
        this.messageInput.addEventListener('input', () => this.updateCount());
      }
      this.fields.forEach((field) => {
        field.addEventListener('input', () => this.clearFieldError(field));
      });
    }

    toggle() {
      const enabled = this.checkbox.checked;

      this.fieldsWrapper.hidden = !enabled;
      this.checkbox.setAttribute('aria-expanded', enabled);

      // Disabled inputs are excluded from the form submission, so no
      // recipient properties are added when the box is unchecked.
      this.fields.forEach((field) => { field.disabled = !enabled; });
      this.offsetInput.disabled = !enabled;
      this.offsetInput.value = enabled ? new Date().getTimezoneOffset().toString() : '';

      if (!enabled) this.clearErrors();
    }

    setDateLimits() {
      if (!this.dateInput) return;
      const toISODate = (date) => {
        const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return local.toISOString().split('T')[0];
      };
      const today = new Date();
      const max = new Date();
      max.setDate(today.getDate() + GiftCardRecipient.MAX_SEND_DAYS);

      this.dateInput.min = toISODate(today);
      this.dateInput.max = toISODate(max);
    }

    updateCount() {
      if (this.counter) this.counter.textContent = this.messageInput.value.length;
    }

    validate() {
      if (!this.checkbox.checked) return true;
      this.clearErrors();

      const errors = {};
      const email = this.querySelector('[data-recipient-field="email"]');
      const emailValue = email.value.trim();

      if (!emailValue) {
        errors.email = ['Please enter the recipient’s email'];
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)) {
        errors.email = ['Please enter a valid email address'];
      }

      if (this.dateInput && this.dateInput.value) {
        const value = this.dateInput.value;
        if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || value < this.dateInput.min || value > this.dateInput.max) {
          errors.send_on = [`Choose a date between today and ${GiftCardRecipient.MAX_SEND_DAYS} days from now`];
        }
      }

      if (Object.keys(errors).length) {
        this.displayErrors(errors);
        return false;
      }
      return true;
    }

    displayErrors(errors) {
      const unmatched = [];
      let matched = false;

      Object.entries(errors).forEach(([key, value]) => {
        const message = Array.isArray(value) ? value.join(', ') : String(value);
        const field = this.querySelector(`[data-recipient-field="${key}"]`);

        if (field) {
          matched = true;
          const errorEl = document.getElementById(`${field.id}-error`);
          field.setAttribute('aria-invalid', 'true');
          if (errorEl) {
            errorEl.querySelector('span').textContent = message;
            errorEl.classList.remove('hidden');
          }
        } else {
          unmatched.push(message);
        }
      });

      if (matched || unmatched.length) {
        this.errorSummaryText.textContent = unmatched.length
          ? unmatched.join(' ')
          : 'Please check the gift recipient details below.';
        this.errorSummary.classList.remove('hidden');
        const firstInvalid = this.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
      }
    }

    clearFieldError(field) {
      field.removeAttribute('aria-invalid');
      const errorEl = document.getElementById(`${field.id}-error`);
      if (errorEl) errorEl.classList.add('hidden');
      if (!this.querySelector('[aria-invalid="true"]')) this.errorSummary.classList.add('hidden');
    }

    clearErrors() {
      this.fields.forEach((field) => this.clearFieldError(field));
      this.errorSummary.classList.add('hidden');
    }

    reset() {
      this.fields.forEach((field) => { field.value = ''; });
      this.checkbox.checked = false;
      this.toggle();
      this.updateCount();
    }
  });
}
